import React, { useEffect, useRef, useState } from "react";
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js';
import { analytics } from './firebase';
import { logEvent } from 'firebase/analytics';
import Admin from './Admin';

// Training plans are now handled on the server side for security


export default function HamadorOnlinePrograms_LimeDark_v3_3() {
  // Check if this is admin page
  const isAdminPage = window.location.pathname === '/admin';
  
  if (isAdminPage) {
    return <Admin />;
  }
  const [form, setForm] = useState({
    fullName: "",
    email: "",
    emailConfirm: "",
    phone: "",
    age: "",
    gender: "",
    location: "",
    oneKmTime: "",
    pullUps: "",
    dips: "",
    healthy: false,
  });
  const [step, setStep] = useState('form'); // 'form' | 'payment' | 'success'
  const [validatedData, setValidatedData] = useState(null);
  const [error, setError] = useState("");
  const [fieldErrors, setFieldErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const isMounted = useRef(true);
  
  useEffect(() => { return () => { isMounted.current = false; }; }, []);

  // ===== Helpers =====
  const parseTimeToSeconds = (mmss) => {
    const m = (mmss || '').trim();
    const parts = m.split(":");
    if (parts.length !== 2) return NaN;
    const mm = Number(parts[0]);
    const ss = Number(parts[1]);
    if (!Number.isInteger(mm) || !Number.isInteger(ss)) return NaN;
    if (mm < 0 || ss < 0 || ss > 59) return NaN;
    return mm * 60 + ss;
  };
  const isEmail = (v) => /[^\s@]+@[^\s@]+\.[^\s@]+/.test(v || "");
  const isIsraeliPhone = (v) => /^(05\d-?\d{7})$/.test(v || "");

  // Training plan logic is now handled on the server side

   function validate(f){
     const errs = {};
     const maxOneKmSec = 5*60 + 10;
     const tSec = parseTimeToSeconds(f.oneKmTime);
     // השדות הבאים הושבתו זמנית:
     // if(!f.fullName) errs.fullName = true;
     // if(!f.email || !isEmail(f.email)) errs.email = true;
     // if(!f.emailConfirm || f.emailConfirm !== f.email) errs.emailConfirm = true;
     // if(!f.age) errs.age = true;
     // if(!f.pullUps) errs.pullUps = true;
     // if(!f.dips) errs.dips = true;
     // if(!f.location) errs.location = true;
     // if(!f.gender) errs.gender = true;
     
     if(!f.phone || !isIsraeliPhone(f.phone)) errs.phone = true;
     if(!f.oneKmTime || !Number.isFinite(tSec) || tSec > maxOneKmSec) errs.oneKmTime = true;
     if(!f.healthy) errs.healthy = true;
     return errs;
   }

  // ===== Handlers =====
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
    setFieldErrors((prev) => ({ ...prev, [name]: false }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    const errs = validate(form);
    setFieldErrors(errs);
    if(Object.keys(errs).length){
      // בדיקות ספציפיות לכל שדה
      if(errs.fullName) {
        setError("אנא הזן את השם המלא שלך");
        return;
      }
           if(errs.phone) {
             setError("אנא הזן מספר טלפון ישראלי תקין (05X-XXXXXXX)");
             return;
           }
      if(errs.oneKmTime) {
        setError("אנא הזן זמן ריצה תקין (מקסימום 05:10)");
        return;
      }
      if(errs.pullUps) {
        setError("אנא הזן מספר מתח תקין (מינימום 2)");
        return;
      }
      if(errs.dips) {
        setError("אנא הזן מספר מקבילים תקין (מינימום 4)");
        return;
      }
      if(errs.healthy) {
        setError("אנא אשר שאתה בריא ואין בעיות רפואיות");
        return;
      }
      // הודעת שגיאה כללית למקרים שלא כוסו
      setError("אנא מלא את כל השדות הנדרשים");
      return;
    }

    setLoading(true);

         // הכנת הנתונים
         const userData = {
           phone: form.phone,
           oneKmTime: form.oneKmTime,
           runTime: parseTimeToSeconds(form.oneKmTime),
           healthy: form.healthy
         };

    // יצירת הזמנה במצב ממתין לתשלום ושמירת orderId
    try {
      const resp = await fetch('https://us-central1-hamador-6119e.cloudfunctions.net/saveOrderData', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userData, paymentConfirmed: false })
      });

      if (!resp.ok) {
        setError('אירעה שגיאה בשמירת המידע. אנא נסה שוב.');
        setLoading(false);
        return;
      }

      const data = await resp.json();
      const createdOrderId = data?.orderId;

      // שמירה ב-state כדי שנוכל לעדכן לאחר התשלום
      setValidatedData({ userData, orderId: createdOrderId });
      setStep('payment'); // מעבר לשלב תשלום
      
      // Analytics - טופס הושלם
      if (analytics) {
        console.log('Sending form_submit event to Analytics');
        logEvent(analytics, 'form_submit', {
          form_name: 'training_program_form',
          user_data: {
            age: userData.age,
            gender: userData.gender,
            run_time: userData.runTime
          }
        });
      } else {
        console.log('Analytics not available');
      }
    } catch (e) {
      setError('אירעה שגיאה בחיבור לשרת.');
    } finally {
      setLoading(false);
    }
  };


  return (
    <div dir="rtl" className="min-h-screen text-white">
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
      <link href="https://fonts.googleapis.com/css2?family=Assistant:wght@300;400;600;700;800&family=Rubik:wght@400;700;900&display=swap" rel="stylesheet" />

             <style>{`
               :root{
                 --brand-green: #00B26F;
                 --brand-light-green: #E9F7EE;
                 --text-dark: #1a1a1a;
                 --text-light: #ffffff;
               }
               *{font-family:'Assistant','Rubik','Noto Sans Hebrew',system-ui,-apple-system,'Segoe UI','Noto Sans',Arial,sans-serif}
               .hero-gradient{background: #101827;}
               .what-you-get-bg{background: white;}
               .special-advantage-bg{background: linear-gradient(135deg, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0.2) 100%), url('/hero-bg.avif'); background-size: cover; background-position: center; background-repeat: no-repeat;}
               .card-hover{transition: all 0.3s ease; transform: translateY(0);}
               .card-hover:hover{transform: translateY(-8px); box-shadow: 0 20px 40px rgba(0,0,0,0.15);}
               .btn-primary{background: var(--brand-green); color: white; font-weight: 700; border-radius: 12px; transition: all 0.3s ease;}
               .btn-primary:hover{background: #008F5A; transform: translateY(-2px); box-shadow: 0 8px 25px rgba(0,178,111,0.3);}
               .text-gradient{background: linear-gradient(135deg, var(--brand-green) 0%, var(--brand-orange) 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text;}
               .panel{background: rgba(255,255,255,0.95); color: var(--text-dark); border-radius: 20px; box-shadow: 0 10px 30px rgba(0,0,0,0.1);}
               .form-input{background: white; border: 2px solid #e5e7eb; border-radius: 12px; transition: all 0.3s ease;}
               .form-input:focus{border-color: var(--brand-green); box-shadow: 0 0 0 3px rgba(0,178,111,0.1);}
               .invalid{border-color: #ef4444; box-shadow: 0 0 0 3px rgba(239,68,68,0.1);}
             `}</style>

      {/* Hero Section */}
      <section className="hero-gradient min-h-screen flex items-center justify-center relative overflow-hidden">
        <div className="max-w-6xl mx-auto px-4 text-center relative z-10">
          {/* Logo */}
          <div className="mb-8">
            <img src="/logo.png" alt="המדור כושר קרבי" className="w-64 md:w-80 h-auto mx-auto drop-shadow-2xl" />
          </div>
          
                 {/* Main Headline */}
                 <h1 className="text-4xl md:text-6xl lg:text-7xl font-black mb-6 leading-tight">
                   <span className="block text-white" style={{textShadow: '1px 1px 2px rgba(0,0,0,0.8)'}}>תכנית האימונים האונליין</span>
                   <span className="block text-white" style={{textShadow: '1px 1px 2px rgba(0,0,0,0.8)'}}>ליום סיירות – ינואר 2026</span>
                   <span className="block text-3xl md:text-5xl lg:text-6xl mt-4 text-white" style={{textShadow: '1px 1px 2px rgba(0,0,0,0.8)'}}>תוצאות תוך שבועיים!</span>
                 </h1>
          
          {/* Subtitle */}
          <p className="text-xl md:text-2xl text-white mb-12 max-w-4xl mx-auto leading-relaxed font-medium" style={{textShadow: '1px 1px 2px rgba(0,0,0,0.8)'}}>
            ההכנה שלך ליום הסיירות מתחילה כאן – תכנית אונליין מותאמת אישית שתוביל אותך לשיא הכושר עד ינואר!
          </p>
          
          {/* CTA Button */}
          <button 
            onClick={() => document.getElementById('form-section').scrollIntoView({ behavior: 'smooth' })}
            className="text-xl md:text-2xl px-12 py-6 rounded-2xl font-bold shadow-2xl text-white border-2 border-white/30 hover:border-white/60 transition-all duration-300"
            style={{backgroundColor: 'rgba(0, 178, 111, 0.9)', backdropFilter: 'blur(10px)'}}
          >
            התחל עכשיו
          </button>
        </div>
      </section>

      {/* What You Get Section */}
      <section className="what-you-get-bg py-20">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-4xl md:text-5xl font-black text-center mb-16 text-gray-800">
            מה תקבל בתכנית
          </h2>

          <div className="grid md:grid-cols-3 gap-8">
            {/* Card 1 */}
            <div className="card-hover bg-white p-8 rounded-2xl shadow-lg border border-gray-100 text-center">
              <div className="text-6xl mb-6">🕐</div>
              <h3 className="text-2xl font-bold mb-4 text-gray-800">תכנית אינטרוולים</h3>
              <p className="text-gray-600 text-lg leading-relaxed">כדי לוודא שאתה עובר את בוחן הכניסה של ה-1 קמ ואתה מגיע בשיא הכושר הגופני לדיונות</p>
            </div>

            {/* Card 2 */}
            <div className="card-hover bg-white p-8 rounded-2xl shadow-lg border border-gray-100 text-center">
              <div className="text-6xl mb-6">🏔️</div>
              <h3 className="text-2xl font-bold mb-4 text-gray-800">אימוני דיונה</h3>
              <p className="text-gray-600 text-lg leading-relaxed">תכנית ממוקדת לפי התחנות הפיזיות:<br/>צוקון, זחילות וחפירת בורות</p>
            </div>

            {/* Card 3 */}
            <div className="card-hover bg-white p-8 rounded-2xl shadow-lg border border-gray-100 text-center">
              <div className="text-6xl mb-6">🎯</div>
              <h3 className="text-2xl font-bold mb-4 text-gray-800">דגשים לתחנות</h3>
              <p className="text-gray-600 text-lg leading-relaxed">על מה חשוב להקפיד בכל תחנה - אלונקה סוציומטרית, צוקון, זחילות משולב עלייה עם שק, חפירת בור, משימות צוות</p>
            </div>
          </div>
        </div>
      </section>

      {/* Special Advantage Section */}
      <section className="special-advantage-bg py-20 text-white">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <div className="text-6xl mb-8">📅</div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white" style={{textShadow: '1px 1px 2px rgba(0,0,0,0.8)'}}>
            כל שבועיים אתה מקבל תכנית חדשה בהתאם להתקדמות שלך!
          </h2>
          <p className="text-xl text-white leading-relaxed font-medium" style={{textShadow: '1px 1px 2px rgba(0,0,0,0.8)'}}>
            התכנית מתאימה את עצמה אליך – בדיוק כמו מאמן אישי, רק אונליין.
          </p>
        </div>
      </section>

      {/* Special Offer Section */}
      <section className="py-20 bg-gray-900">
        <div className="max-w-6xl mx-auto px-4">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-3 mb-6">
              <span className="text-4xl">🔥</span>
              <h2 className="text-3xl md:text-4xl font-black text-white">מבצע מיוחד לנרשמים עד 31/10/25</h2>
            </div>
          </div>
          
          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Offer Details */}
            <div className="space-y-6">
               <div className="text-center md:text-right">
                 <div className="text-6xl font-black text-white mb-4">
                   <span className="text-gray-400 line-through text-4xl">150 ₪</span>
                   <span className="text-white"> 29 ₪</span>
                 </div>
                 <p className="text-2xl text-gray-300">רק במקום!</p>
               </div>
              
                     <div className="space-y-4 text-lg text-gray-300">
                       <div className="flex items-center gap-3">
                         <span className="text-2xl text-green-400">✓</span>
                         <span>כניסה חינם לאימון אחד בכל חודש עד ינואר</span>
                       </div>
                       <div className="flex items-center gap-3">
                         <span className="text-2xl text-green-400">✓</span>
                         <span>זום הכנה מקצועי בדצמבר</span>
                       </div>
                       <div className="flex items-center gap-3">
                         <span className="text-2xl text-green-400">✓</span>
                         <span>הנחה לסימולציית יום סיירות (בהתאם למקום פנוי)</span>
                       </div>
                     </div>
            </div>
            
            {/* Form */}
            <div id="form-section" className="panel p-8">
              <h3 className="text-2xl md:text-3xl font-bold text-center mb-8 text-gray-800">
                מוכן להתחיל?
              </h3>
              <p className="text-center text-gray-600 mb-8 text-lg">
                כל מה שנשאר לך זה לכתוב בכמה זמן אתה רץ 1 ק"מ —<br/>
                והתכנית הראשונה שלך תישלח אליך עוד היום 💪
              </p>
              {step === 'form' && (
                <form onSubmit={handleSubmit} className="space-y-6" noValidate>
                  <div>
                    <label htmlFor="oneKmTime" className="block mb-3 text-lg font-bold text-gray-800">מה תוצאת הריצה של 1 ק"מ?</label>
                    <input 
                      id="oneKmTime" 
                      name="oneKmTime" 
                      type="text" 
                      pattern="^([0-9]|0[0-9]|[1-5][0-9]):[0-5][0-9]$" 
                      title="פורמט דק׳:שניות (למשל 04:15)" 
                      required 
                      placeholder="04:00" 
                      className={`form-input w-full px-6 py-4 text-lg ${fieldErrors.oneKmTime? 'invalid':''}`} 
                      value={form.oneKmTime} 
                      onChange={handleChange} 
                    />
                    <p className="text-sm text-gray-500 mt-2">מקסימום מותר: 05:10 דק׳</p>
                  </div>



                  <div>
                    <label htmlFor="phone" className="block mb-3 text-lg font-bold text-gray-800">טלפון (התוכנית תשלח לווטסאפ)</label>
                    <input 
                      id="phone" 
                      name="phone" 
                      type="tel" 
                      required 
                      placeholder="05X-XXXXXXX" 
                      className={`form-input w-full px-6 py-4 text-lg ${fieldErrors.phone? 'invalid':''}`} 
                      value={form.phone} 
                      onChange={handleChange} 
                    />
                  </div>

                  <div className="bg-gray-50 p-6 rounded-xl">
                    <label className={`flex items-start gap-3 text-lg font-bold text-gray-800 ${fieldErrors.healthy? 'text-red-500':''}`}>
                      <input type="checkbox" name="healthy" checked={form.healthy} onChange={handleChange} required className="w-5 h-5 mt-1" />
                      <span>אני בריא/ה ואין בעיות רפואיות שמונעות ממני פעילות גופנית</span>
                    </label>
                  </div>

                  <button type="submit" className="btn-primary w-full py-4 text-xl font-bold" disabled={loading}>
                    {loading ? 'מעבד…' : 'התחל עכשיו - 29 ₪'}
                  </button>

                  {error && (
                    <div className="mt-4 p-4 bg-red-50 border border-red-200 rounded-xl text-red-600 text-center font-bold">
                      {error}
                    </div>
                  )}
                </form>
              )}

          {step === 'payment' && (
            <div className="text-center py-6">
              <h3 className="text-2xl font-black mb-6" style={{color:'var(--brand-accent)'}}>סיכום ההזמנה</h3>
              
             <div className="bg-gray-800 rounded-xl p-6 mb-6 text-right">
               <h4 className="text-lg font-bold mb-4 text-white">פרטי ההזמנה שלך:</h4>
               <div className="space-y-2 text-sm text-white">
                 <p><strong>טלפון:</strong> {validatedData?.userData.phone}</p>
                 <p><strong>זמן ריצה:</strong> {validatedData?.userData.oneKmTime}</p>
                 <p><strong>מחיר:</strong> 29 ₪</p>
               </div>
             </div>

             <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 mb-6">
               <p className="text-blue-800 text-sm font-medium">
                 <strong>הערה:</strong> לאחר התשלום, המידע יישמר במערכת והתוכנית תישלח לווטסאפ שלך.
               </p>
             </div>

            {/* PayPal Button - Production JS SDK */}
            <div className="mb-6 text-center">
              <PayPalScriptProvider options={{ 
                "client-id": "AT0m1kNN1cBfJN4QDREzaucFtnxjJ3AVNXJfPZMx4tJU2yCTSs-Jcj6UPRAVGOiNccgP1QcQaJTwV3XA",
                currency: "ILS",
                locale: "he_IL"
              }}>
                <PayPalButtons
                  style={{
                    layout: "vertical",
                    color: "gold",
                    shape: "rect",
                    label: "paypal"
                  }}
                  createOrder={(data, actions) => {
                    return actions.order.create({
                      purchase_units: [{
                        amount: {
                          value: "29.00",
                          currency_code: "ILS"
                        },
                        description: "תוכנית אימונים להכנה ליום סיירות 2026"
                      }]
                    });
                  }}
                  onApprove={(data, actions) => {
                    return actions.order.capture().then(async (details) => {
                      console.log('Payment completed:', details);
                      setLoading(true);
                      
                      try {
                        // שמירת המידע בדאטהבייס עם סטטוס "paid"
                        const saveResponse = await fetch('https://us-central1-hamador-6119e.cloudfunctions.net/saveOrderData', {
                          method: 'POST',
                          headers: { 'Content-Type': 'application/json' },
                          body: JSON.stringify({
                            userData: validatedData.userData,
                            orderId: validatedData.orderId,
                            paymentConfirmed: true,
                            paypalOrderId: details.id,
                            paypalDetails: details
                          })
                        });

                        if (!saveResponse.ok) {
                          setError('אירעה שגיאה בשמירת המידע. אנא נסה שוב.');
                          return;
                        }

                        // מעבר ישיר למסך הצלחה
                        setStep('success');
                        
                        // Analytics - תשלום הושלם
                        if (analytics) {
                          logEvent(analytics, 'purchase', {
                            transaction_id: details.id,
                            value: 29,
                            currency: 'ILS',
                            items: [{
                              item_id: 'training_program',
                              item_name: 'תוכנית אימונים להכנה ליום סיירות 2026',
                              category: 'training',
                              quantity: 1,
                              price: 29
                            }]
                          });
                        }
                      } catch (err) {
                        setError('אירעה שגיאה בחיבור לשרת.');
                      } finally {
                        setLoading(false);
                      }
                    });
                  }}
                  onError={(err) => {
                    console.error('PayPal error:', err);
                    setError('אירעה שגיאה בתשלום PayPal. אנא נסה שוב.');
                  }}
                />
              </PayPalScriptProvider>
            </div>



            {/* Powered by PayPal text */}
            <div className="text-center">
              <p className="text-sm text-gray-400 mt-4">מופעל על-ידי <img src="https://www.paypalobjects.com/paypal-ui/logos/svg/paypal-wordmark-color.svg" alt="paypal" style={{height:'0.875rem',verticalAlign:'middle', display: 'inline-block'}}/></p>
            </div>

              {error && (
                <div className="mt-4 text-sm font-bold" style={{color:'#ff4d4f'}}>{error}</div>
              )}
            </div>
          )}

        {step === 'success' && (
          <div className="text-center py-10">
            <h3 className="text-2xl font-black mb-6" style={{color:'var(--brand-accent)'}}>התשלום הושלם בהצלחה! 🎉</h3>
            
           <div className="bg-green-900/20 border border-green-600/30 rounded-xl p-6 mb-6">
             <p className="text-green-200 mb-4">
               ✅ <strong>הצלחה!</strong> התשלום הושלם והתוכנית תשלח לווטסאפ
             </p>
             <p className="text-lg font-bold text-white">{validatedData?.userData.phone}</p>
             <p className="text-sm text-green-200 mt-2">
               התוכנית תשלח לווטסאפ שלך תוך 24 שעות
             </p>
           </div>

            <div className="bg-blue-900/20 border border-blue-600/30 rounded-xl p-4 mb-6">
              <p className="text-blue-200 text-sm">
                📧 לתמיכה ניתן לפנות אלינו במייל info@hamador.co.il
              </p>
            </div>

              <button 
                onClick={() => { 
                  setStep('form'); 
                  setValidatedData(null);
                  setForm({
                    fullName: "",
                    email: "",
                    emailConfirm: "",
                    phone: "",
                    age: "",
                    gender: "",
                    location: "",
                    oneKmTime: "",
                    pullUps: "",
                    dips: "",
                    healthy: false,
                  });
                }} 
                className="btn px-8 py-3"
              >
                חזרה לדף הבית
              </button>
            </div>
          )}
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-12 bg-gray-800">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <div className="mb-6">
            <img src="/logo.png" alt="המדור כושר קרבי" className="w-24 h-auto mx-auto opacity-80" />
          </div>
          <p className="text-gray-400 text-lg">© {new Date().getFullYear()} המדור – כושר קרבי</p>
          <p className="text-gray-500 text-sm mt-2">הכנה מקצועית ליום הסיירות</p>
        </div>
      </footer>
    </div>
  );
}
